import { render, staticRenderFns } from "./InscripcionesProductividadLayout.vue?vue&type=template&id=c0ae19f2&scoped=true"
import script from "./InscripcionesProductividadLayout.vue?vue&type=script&lang=js"
export * from "./InscripcionesProductividadLayout.vue?vue&type=script&lang=js"
import style0 from "./InscripcionesProductividadLayout.vue?vue&type=style&index=0&id=c0ae19f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ae19f2",
  null
  
)

export default component.exports